import Styled from 'styled-components';

// import { media } from '../../../../lib/StyledComponents';

export const VerTask = Styled.div`
  display: flex;
`;
